import React from "react";
import { CurrencySymbol } from "utils/utils";

const DisplayPrice = ({
  value = 0,
  width = "15",
  height = "16",
  color = "#0F0F0F",
}) => {
  return (
    <div className="ltr common_price">
      <CurrencySymbol width={width} height={height} color={color} />
      {value}
    </div>
  );
};

export default DisplayPrice;
